// // EmptyStateOverlay.tsx
// import React from 'react';
// import { Box, Typography, Button } from '@mui/material';

// interface EmptyStateOverlayProps {
//   onNavigate: () => void;
//   userRole?: string | null;
//   title: string;       // New: Customizable title
//   message: string;     // New: Customizable message
//   buttonText: string;  // New: Customizable button text
//   imageSrc: string;    // New: Customizable image source
// }

// const EmptyStateOverlay: React.FC<EmptyStateOverlayProps> = ({
//   onNavigate,
//   userRole,
//   title,
//   message,
//   buttonText,
//   imageSrc,
// }) => (
//   <Box
//     sx={{
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       backgroundColor: 'rgba(255, 255, 255, 0.5)',
//       backdropFilter: 'blur(5px)',
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'center',
//       alignItems: 'center',
//       zIndex: 10,
//       p: 2,
//       textAlign: 'center',
//     }}
//   >
//     <Box sx={{
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       ml: 12 // Adjust this number to move it more or less to the right
//     }}>
//       <img src={imageSrc} alt="No Data" style={{ width: '150px', height: '150px', marginBottom: '12px' }} />

//       <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
//         {title}
//       </Typography>

//       <Typography variant="body1" color="text.secondary" sx={{ mb: 2, maxWidth: '400px' }}>
//         {message}
//       </Typography>

//       {userRole !== 'viewer' && (
//         <Button disableElevation variant="contained" onClick={onNavigate} sx={{ fontFamily: 'Inter', backgroundColor: '#0064FF', fontSize: '14px', fontWeight: 500, borderRadius: '8px', textTransform: 'none' }}>
//           {buttonText}
//         </Button>
//       )}
//     </Box>
//   </Box>
// );

// export default EmptyStateOverlay;


// EmptyStateOverlay.tsx
import React from 'react';
import { Box, Typography, Button } from '@mui/material';

interface EmptyStateOverlayProps {
  onNavigate?: () => void;   // Changed: Now optional
  userRole?: string | null;
  title: string;
  message: string;
  buttonText?: string;  // Changed: Now optional
  imageSrc: string;
}

const EmptyStateOverlay: React.FC<EmptyStateOverlayProps> = ({
  onNavigate,
  userRole,
  title,
  message,
  buttonText,
  imageSrc,
}) => (
  <Box
    sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
      backdropFilter: 'blur(5px)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 10,
      p: 2,
      textAlign: 'center',
    }}
  >
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      ml: 12
    }}>
      <img src={imageSrc} alt="No Data" style={{ width: '150px', height: '150px', marginBottom: '12px' }} />

      <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
        {title}
      </Typography>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 2, maxWidth: '400px' }}>
        {message}
      </Typography>

      {/* This is the key change: only render the button if it has text and a navigation action */}
      {userRole !== 'viewer' && buttonText && onNavigate && (
        <Button 
          disableElevation 
          variant="contained" 
          onClick={onNavigate} 
          sx={{ fontFamily: 'Inter', backgroundColor: '#0064FF', fontSize: '14px', fontWeight: 500, borderRadius: '8px', textTransform: 'none' }}
        >
          {buttonText}
        </Button>
      )}
    </Box>
  </Box>
);

export default EmptyStateOverlay;